import axios from '@/server/axios'


export function queryContact() {
  return axios({
    url: 'officialWebsite/queryInfo.do',
    method: 'get',
    params: {

    }
  })
}